export default __webpack_public_path__ + "static/media/6-29-19-bowie.fc6d9ed2.m4a";